module.exports = __webpack_public_path__ + "static/media/frame_88.1289f1ed.jpg";